import { gql } from "@apollo/client";

// export const CLAIM_SUCCESS = gql`
//   mutation claim_succes {
//     claim_success
//   }
// `;

export const UPDATE_NOTIFICATIONS_STATUS = gql`
  mutation notifications_status($status: String!) {
    notifications_status(status: $status)
  }
`;

export const APPLY_CLAIM = gql`
  mutation apply_claim($email: String!, $amount: String!) {
    apply_claim(email: $email, amount: $amount)
  }
`;

export const UPDATE_PROFILE = gql`
  mutation update_profile($name: String, $nickname: String, $email: String) {
    update_profile(name: $name, nickname: $nickname, email: $email) {
      success
    }
  }
`;
